import { Controller } from "@hotwired/stimulus"

// Copy-link button. Takes a path and copies the absolute URL (built from
// the current origin, since card partials also render in broadcasts where
// the server has no request host), then swaps to a check icon briefly.
//
// Values:  data-clipboard-path-value="/time_activities/123"
// Targets: icon (shown normally), done (shown after copying)
export default class extends Controller {
  static values = { path: String }
  static targets = ["icon", "done"]

  async copy(event) {
    event.preventDefault()
    const url = new URL(this.pathValue, window.location.origin).toString()

    try {
      await navigator.clipboard.writeText(url)
    } catch {
      window.prompt("Copy this link:", url)
      return
    }

    this.toggle(true)
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.toggle(false), 1500)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  toggle(copied) {
    if (this.hasIconTarget) this.iconTarget.classList.toggle("hidden", copied)
    if (this.hasDoneTarget) this.doneTarget.classList.toggle("hidden", !copied)
    this.element.title = copied ? "Link copied" : "Copy link"
  }
}
